import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/RegisterAssets/registerAsset.scss'
import { FormControl, InputAdornment, TextField, Typography, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SelectItem from '../SelectItem/selectItem';
import SelectStore from '../SelectStore/selectStore';
import { HIDE_MODAL_ASSETGROUP, HIDE_MODAL_SELECT_ITEM, HIDE_MODAL_SELECT_STORE, POST_REGISTER_ASSET_VERIFY_OTP_DATA, SELECTED_DATA_DECREMENT, SELECTED_DATA_INCREMENT, SELECT_STORE_DATA, SET_PURCHASED_DATA, SHOW_MODAL_SELECT_ITEM, SHOW_MODAL_SELECT_STORE } from '../../../../../../sagas/type';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import TermsConditions from '../TermsConditions/termsConditions';
import ClearIcon from '@mui/icons-material/Clear';
import Asset from '../AssetGroup/asset';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { setLocalStoreString } from '../../../../../../utils/Helper';
import { ASSET_SELECT_STORE_PATH } from '../../../../../../utils/Constants';

function registerAsset() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { RegisterAssetDataPurchase, SelectedStoreDatas, showModalSlectItem, shoModalAssetGroup, showModalSlectStore, PurchasedData } = useSelector(mapStateToProps);
    const { enqueueSnackbar } = useSnackbar();
    const [isShowTnc, setShowTnc] = useState(false)
    const [selectedItemsData, setSelectItemsData] = useState([])
    const [checkedObject, setCheckedObject] = useState()
    const [items, setItems] = useState([])
    const [selectData, setSelectData] = useState({
        selectItem: "",
        selectStore: "",
        selectStoreCode: "",
        purchaseId: "",
        address: ""
    })
    const [checked, setChecked] = useState(false);
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const [searchName, setSearchName] = useState('');
    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }

    console.log("location?.state", location?.state);

    useEffect(() => {
        if (location?.state) {
            const { storeData } = location.state;
            const { name, code, address } = storeData;
            setLocalStoreString("storeName", name)
            setLocalStoreString("storeCode", code)
            setSelectData((selectDatas) => ({ ...selectDatas, selectStore: name, selectStoreCode: code, address: address }));
        }
    }, [location?.state])

    useEffect(() => {
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase?.length) {
            setItems(RegisterAssetDataPurchase)
        }
    }, [RegisterAssetDataPurchase])

    useEffect(() => {
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase?.length) {
            const filterData = RegisterAssetDataPurchase?.filter((item) => item?.purchaseId == checkedObject?.purchaseId)
            handleIncreaseCount(filterData)
        }
    }, [RegisterAssetDataPurchase])

    const handleBack = () => {
        dispatch({ type: SHOW_MODAL_SELECT_ITEM })
    }

    const handleClearSelectStore = () => {
        dispatch({ type: SELECT_STORE_DATA, payload: {} })
    }

    const handleSelectItemModal = () => {
        dispatch({ type: SHOW_MODAL_SELECT_ITEM })
    }


    const mergeArrays = (array1, array2) => {
        const mergeArray = [...array1]
        for (const obj2 of array2) {
            const matchingIndex = mergeArray.findIndex(obj1 => obj1?.purchaseId === obj2?.purchaseId)
            if (matchingIndex !== -1) {
                mergeArray[matchingIndex] = obj2;
            } else {
                mergeArray.push(obj2)
            }
        }

        return mergeArray
    };


    const handleGetVerifyOtp = () => {
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase.length) {
            // const selectPurchaseId1 = Array.from(new Set(RegisterAssetDataPurchase?.filter(item => item?.count > 0).map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str)).map((item) => ({ purchaseId: item?.purchaseId, quantity: item?.count }))
            const selectPurchaseId = RegisterAssetDataPurchase?.filter(item => item?.count > 0 && item?.checked == true)?.filter((element) => element?.type?.toLowerCase().includes(searchName?.toLowerCase())).map((item) => ({ purchaseId: item?.purchaseId, quantity: item?.count }))

            const mergedArray = mergeArrays(selectPurchaseId, PurchasedData)
            dispatch({
                type: POST_REGISTER_ASSET_VERIFY_OTP_DATA,
                payload: { storeData: SelectedStoreDatas },
                enqueueSnackbar: enqueueSnackbar,
                navigate: navigate,
                selectedItemsPurchaseId: mergedArray,
            })
        }
    }

    const handleClickClearItem = (id) => {
        const filterData = RegisterAssetDataPurchase?.filter((item) => item?.purchaseId !== id)
        setSelectItemsData(filterData)
    }

    const handleDone = () => {
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
        dispatch({ type: HIDE_MODAL_ASSETGROUP })
        dispatch({ type: HIDE_MODAL_SELECT_ITEM })
    }
    const handleCountChange = (selectedData, type) => {
        setCheckedObject(selectedData)
        if (type) {
            dispatch({
                type: SELECTED_DATA_INCREMENT,
                payload: selectedData,
            })
        } else {
            dispatch({
                type: SELECTED_DATA_DECREMENT,
                payload: selectedData,
            })
        }
        handleIncreaseCount(selectedData)
    }

    const handleSelectStoreModal = () => {
        // dispatch({ type: SHOW_MODAL_SELECT_STORE })
        navigate(ASSET_SELECT_STORE_PATH)
    }

    const validateForm = () => {
        let isValid = false
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase?.length) {
            const checkSelectItem = RegisterAssetDataPurchase?.filter(item => item?.count > 0 && item?.checked == true).map(item => item)
            if (checkSelectItem?.length > 0 && SelectedStoreDatas?.length > 0 && checked) isValid = true;
            return isValid;
        }
    };

    const handleIncreaseCount = (selectedData) => {
        const result = items?.reduce((result, current) => {
            const existingObject = result.find(item => item.name === current.name);
            if (existingObject) {
                existingObject.totalUnits += current.totalUnits;
                existingObject.issuedCount += current.issuedCount;
                existingObject.nonIssuedCount += current.nonIssuedCount;
                existingObject.combineObject = true
            } else {
                result.push({ ...current });
            }

            return result;
        }, []);
        const duplicateNames = items?.reduce((result, currentPurchase, index, array) => {
            const isDuplicate = array.findIndex(p => p.name === currentPurchase.name) !== index;

            if (isDuplicate && !result.includes(currentPurchase.name)) {
                result.push(currentPurchase.name);
            }
            return result;
        }, []);
        const filterData = items?.filter((item) => item?.name == selectedData[0]?.name)
        const duplicate = filterData?.filter(purchase => duplicateNames?.includes(purchase.name))?.sort((a, b) => a?.nonIssuedCount - b?.nonIssuedCount);
        const duplicateObjects = generatePayload(duplicate, selectedData[0]?.count);
        if (duplicateObjects?.length > 0) {
            dispatch({
                type: SET_PURCHASED_DATA,
                payload: duplicateObjects,
            })
        }
        for (const obj of duplicateObjects) {
            if (selectedData[0]?.count <= obj?.nonIssuedCount) {
                const filterObj = result?.map((item) => {
                    if (item?.name === selectedData[0]?.name) {
                        return { ...item, purchaseId: obj?.purchaseId, nonIssuedCount: obj?.nonIssuedCount };
                    }
                    return item;
                }).filter(Boolean);
                setItems(filterObj)
                break;
            }
        }
    };

    const generatePayload = (duplicate, quantity) => {
        const payloadData = [];

        for (let i = 0; i < duplicate.length; i++) {
            const { purchaseId, nonIssuedCount, checked } = duplicate[i];

            if (quantity <= nonIssuedCount) {
                payloadData.push({ purchaseId, quantity });
                break;
            } else if (quantity > 0) {
                payloadData.push({ purchaseId, quantity: nonIssuedCount });
                quantity -= nonIssuedCount;
            }
        }
        return payloadData;
    };

    return (
        <>
            <div style={{ padding: (showModalSlectItem || showModalSlectStore) && '0px' }} className='RegisterAsset-Container' >
                <div className='RegisterAsset-Container_header'>
                    <div className='RegisterAsset-Container_head-height '>
                        <img className='RegisterAsset-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='RegisterAsset-Container_header_content'>Register Asset</span>
                    </div>
                </div>
                <div>
                    <Typography className='RegisterAsset-Container_leavetype'>Store<span style={{ color: "rgba(255, 255, 255, 0.30)", fontSize: "22px" }}>*</span></Typography>
                </div>
                <div>
                    <FormControl sx={{ background: `${SelectedStoreDatas && SelectedStoreDatas.length && SelectedStoreDatas !== [] ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, borderRadius: '12px', p: 1, width: 300 }}>
                        {SelectedStoreDatas?.length > 0 ? SelectedStoreDatas?.map((item) => {
                            return (
                                <div key={item?.id} className='RegisterAsset-Container_card-Parent-Container'>
                                    <div className="RegisterAsset-Container_card-Heading">
                                        <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px', lineHeight: '14px', padding: 0 }}>{item?.code} - {item?.name}</Typography>
                                        <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontWeight: 400, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px" }} value="name">{item?.address}</Typography>
                                    </div>
                                    <div>
                                        <ClearIcon sx={{ color: 'rgba(255, 255, 255, 0.30)', position: "absolute", right: "2px", top: "2px" }} onClick={handleClearSelectStore} />
                                    </div>
                                </div>
                            )
                        })
                            :
                            <TextField size="small" type='text' variant="outlined" placeholder='Search Store'
                                onFocus={handleSelectStoreModal}
                                InputProps={{ readOnly: true, startAdornment: (<InputAdornment position='start'> <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} /></InputAdornment>), }}
                            />
                        }
                    </FormControl>
                    {/* {showModalSlectStore && (
                        <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                            <SelectStore setSelectData={setSelectData} />
                        </div>
                    )} */}
                </div>
                <div>
                    <Typography className='RegisterAsset-Container_leavetype'>Select Item<span style={{ color: "rgba(255, 255, 255, 0.30)", fontSize: "22px" }}>*</span></Typography>
                </div>
                <div>
                    <FormControl sx={{ background: `${selectedItemsData.length > 0 ? 'radial-gradient(84.52% 84.52% at 50% 15.48%, rgba(128, 116, 255, 0.3) 0%, rgba(128, 116, 255, 0.3) 100%), rgba(255, 255, 255, 0.06);' : 'rgba(255,255,255,0.18)'}`, borderRadius: '12px', p: 1, width: 300 }}>
                        <TextField size="small" type='text' variant="outlined" placeholder='Search Item' className='RegisterAsset-Container_selectItem-textField' onChange={handleSearch} value={searchName}
                            onFocus={handleSelectItemModal}
                            InputProps={{ readOnly: true, startAdornment: (<InputAdornment position='start' className='RegisterAsset-Container_inputAdornment'><SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} /></InputAdornment>), }} />
                    </FormControl>
                    <div className="RegisterAsset-Container_card-Head">
                        {RegisterAssetDataPurchase?.length > 0 && items?.reduce((result, current) => {
                            const existingObject = result.find(item => item.name === current.name);

                            if (existingObject) {
                                existingObject.totalUnits += current.totalUnits;
                                existingObject.issuedCount += current.issuedCount;
                                existingObject.nonIssuedCount += current.nonIssuedCount;
                                existingObject.combineObject = true
                            } else {
                                result.push({ ...current });
                            }

                            return result;
                        }, []).filter(item => item?.count > 0 && item?.checked == true)?.filter((element) => element?.type?.toLowerCase().includes(searchName?.toLowerCase())).map((item) => {
                            return (
                                <div key={item?.purchaseId} className='RegisterAsset-Container_card-Parent-Container2'>
                                    <div className="RegisterAsset-Container_card-Heading2">
                                        <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', padding: '10px 0px 0px 0px', opacity: "0.5" }}>{item?.type} - {item?.name}</Typography>
                                        <div style={{ display: "flex" }}>
                                            <button disabled={item?.count <= 0 ? true : false} className="RegisterAsset-Container_btn-disable-count" onClick={() => handleCountChange(item)}><RemoveCircleOutlineIcon style={{}} sx={{ color: item.count <= 0 ? 'rgba(255, 255, 255, 0.30)' : '#8074FF', width: "24px", height: "24px", border: "5px" }} /></button>
                                            <Typography sx={{ padding: "1px 10px", color: "#FFF", fontSize: "15px" }}>{item?.count ? item.count : 0}</Typography>
                                            <button disabled={item?.count === item?.nonIssuedCount ? true : false} className="RegisterAsset-Container_btn-disable-count" onClick={() => handleCountChange(item, "Increment")}><AddCircleOutlineRoundedIcon sx={{ color: item.count == item?.nonIssuedCount ? 'rgba(255, 255, 255, 0.30)' : '#8074FF', width: "24px", height: "24px" }} /></button>
                                        </div>
                                    </div>
                                    <div>
                                        <ClearIcon sx={{ display: "none", color: 'rgba(255, 255, 255, 0.30)', width: "16px", height: "16px", position: "absolute", right: "13px", top: "17px" }} onClick={() => handleClickClearItem(item?.purchaseId)} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </div>
                <div className='RegisterAsset-Container_checkbox-container'>
                    <div className='RegisterAsset-Container_checkbox-container_checkbox'>
                        <FormGroup>
                            <FormControlLabel className='RegisterAsset-Container_label-Tnc' control={<Checkbox checked={checked}
                                onChange={handleChange}
                                inputProps={{ 'aria-label': 'controlled' }} className="RegisterAsset-Container_label-Tnc-child" />} label="I agree to the" />
                        </FormGroup>
                    </div>
                    <div>
                        <Typography sx={{ color: '#6B5EF7', fontSize: '12px', textDecorationLine: 'underline' }} onClick={() => setShowTnc(true)}>Terms and Conditions</Typography>
                    </div>
                </div>
                {isShowTnc && (
                    <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                        <TermsConditions setShowTnc={setShowTnc} />
                    </div>
                )}
                <div className='RegisterAsset-Container_registerData_buttonContainer'>
                    <button type='submit' disabled={!validateForm()} className='RegisterAsset-Container_registerData_buttonContainer_active-button' onClick={handleGetVerifyOtp}>Get OTP</button>
                </div>
            </div >
            {shoModalAssetGroup && (
                <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                    <Asset selectData={selectData} />
                </div>
            )}
            {showModalSlectItem && (
                <div style={{ position: "absolute", top: "0px", zIndex: 40, width: "100%" }}>
                    <SelectItem setSelectData={setSelectData} setSelectItemsData={setSelectItemsData} selectedItemsData={selectedItemsData} onDone={handleDone} onCountChange={handleCountChange} />
                </div>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        RegisterAssetDataPurchase: state?.attendanceConfig?.RegisterAssetDataPurchase,
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
        showModalSlectItem: state?.attendanceConfig?.showModalSlectItem,
        shoModalAssetGroup: state?.attendanceConfig?.shoModalAssetGroup,
        showModalSlectStore: state?.attendanceConfig?.showModalSlectStore,
        PurchasedData: state?.attendanceConfig?.PurchasedData,
    }
}

export default registerAsset